/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { OrganizationIndicatorsResource } from './';
import {
    OrganizationIndicatorsResourceFromJSON,
    OrganizationIndicatorsResourceFromJSONTyped,
    OrganizationIndicatorsResourceToJSON,
} from './';
import type { OrganizationManagersResource } from './';
import {
    OrganizationManagersResourceFromJSON,
    OrganizationManagersResourceFromJSONTyped,
    OrganizationManagersResourceToJSON,
} from './';
import type { OrganizationOptionsResource } from './';
import {
    OrganizationOptionsResourceFromJSON,
    OrganizationOptionsResourceFromJSONTyped,
    OrganizationOptionsResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationResource
 */
export interface OrganizationResource {
    /**
     * 
     * @type {string}
     * @memberof OrganizationResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationResource
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationResource
     */
    name?: string;
    /**
     * 
     * @type {OrganizationIndicatorsResource}
     * @memberof OrganizationResource
     */
    indicators: OrganizationIndicatorsResource;
    /**
     * 
     * @type {OrganizationOptionsResource}
     * @memberof OrganizationResource
     */
    options?: OrganizationOptionsResource;
    /**
     * 
     * @type {OrganizationManagersResource}
     * @memberof OrganizationResource
     */
    managers: OrganizationManagersResource;
}

/**
 * Check if a given object implements the OrganizationResource interface.
 */
export function instanceOfOrganizationResource(value: object): value is OrganizationResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('indicators' in value) || value['indicators'] === undefined) return false;
    if (!('managers' in value) || value['managers'] === undefined) return false;
    return true;
}

export function OrganizationResourceFromJSON(json: any): OrganizationResource {
    return OrganizationResourceFromJSONTyped(json, false);
}

export function OrganizationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'name': json['name'] == null ? undefined : json['name'],
        'indicators': OrganizationIndicatorsResourceFromJSON(json['indicators']),
        'options': json['options'] == null ? undefined : OrganizationOptionsResourceFromJSON(json['options']),
        'managers': OrganizationManagersResourceFromJSON(json['managers']),
    };
}

export function OrganizationResourceToJSON(value?: OrganizationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'externalId': value['externalId'],
        'name': value['name'],
        'indicators': OrganizationIndicatorsResourceToJSON(value['indicators']),
        'options': OrganizationOptionsResourceToJSON(value['options']),
        'managers': OrganizationManagersResourceToJSON(value['managers']),
    };
}

